import { render, staticRenderFns, recyclableRender, components } from "./workOrder.vue?vue&type=template&id=6038f4fc&"
var renderjs
import script from "./workOrder.vue?vue&type=script&lang=js&"
export * from "./workOrder.vue?vue&type=script&lang=js&"
import style0 from "./workOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/workOrder/workOrder.vue"
export default component.exports